import { z } from 'zod';

import { dashboardT } from '../../../../lib/messages';
import { DebugEventType, debugRuleEventTypes } from '../../model';

const optionalNumber = z.number().optional();

export const debugRuleDialogSchema = z
  .object({
    publisherId: z.string(),
    publisherSecondaryId: z.string(),
    placementId: z.string(),
    placementSecondaryId: z.string(),
    demandPartnerId: z.string(),
    sampleRate: optionalNumber.refine(
      (value) => value === undefined || (value >= 0 && value <= 1),
      { error: () => dashboardT('debug.form.sampleRateError') },
    ),
    durationSeconds: optionalNumber.refine(
      (value) => value === undefined || (Number.isInteger(value) && value >= 1),
      { error: () => dashboardT('debug.form.durationError') },
    ),
    eventTypes: z.array(z.enum(debugRuleEventTypes)),
    enabled: z.boolean(),
  })
  .superRefine((value, context) => {
    const hasPublisher = Boolean(value.publisherSecondaryId.trim());
    const hasPlacement = Boolean(value.placementSecondaryId.trim());
    const hasDemandPartner = Boolean(value.demandPartnerId.trim());
    if (!hasPublisher && !hasPlacement && !hasDemandPartner) {
      context.addIssue({
        code: 'custom',
        path: ['publisherId'],
        message: dashboardT('debug.form.sourceRequired'),
      });
    }

    const demandPartnerOnly = hasDemandPartner && !hasPublisher && !hasPlacement;
    if (
      demandPartnerOnly &&
      value.eventTypes.some((eventType) => eventType !== DebugEventType.DpRequest)
    ) {
      context.addIssue({
        code: 'custom',
        path: ['eventTypes'],
        message: dashboardT('debug.form.dpOnlyError'),
      });
    } else if (hasDemandPartner && !value.eventTypes.includes(DebugEventType.DpRequest)) {
      context.addIssue({
        code: 'custom',
        path: ['eventTypes'],
        message: dashboardT('debug.form.dpRequiredError'),
      });
    }
  });

export type DebugRuleDialogFormValue = z.infer<typeof debugRuleDialogSchema>;
